module.exports = __webpack_public_path__ + "assets/vercel.a0e00a81.svg";